export class VerifyGuidRequest {
  guid: string;
}
